// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB1RR_60SZSc28nYZIGIDwkw1bEWi8wYu8",
  authDomain: "gender-reveal-cd41a.firebaseapp.com",
  projectId: "gender-reveal-cd41a",
  storageBucket: "gender-reveal-cd41a.appspot.com",
  messagingSenderId: "423237350764",
  appId: "1:423237350764:web:1aeb246c60e19f742c2f49",
  measurementId: "G-WBT9S51QJ6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

const analytics = getAnalytics(app);

export { db };